var RS = require('exports-loader?ResizeSensor!resizeSensor');

/* Don't allow it to be added to window -- note: this is not working */
// delete window.ResizeSensor;

module.exports = RS;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/shim/ResizeSensorShim.js
 ** module id = 112
 ** module chunks = 0
 **/